import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { ChevronLeftOutline } from '@olist/design-system-icons';
import { BackButton } from './styles.js';

const DropdownBackButton = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(BackButton, Object.assign({}, props, { type: "button" }),
        React.createElement(ChevronLeftOutline, null),
        "voltar"));
};

export { DropdownBackButton as default };
